import { Box, IconButton, Typography, Switch } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import ReminderEditor, { ReminderEditorValue } from "./ReminderEditor";
import { NotificationsActiveOutlined } from "@mui/icons-material";
import { colors } from "../../../ui/colors";
import { Reminder } from "../../interfaces/IRemiders";

interface Props {
  reminder: Reminder;
  onToggle: (uid: string, nextIsActive: boolean) => void;
  onSave: (uid: string, data: ReminderEditorValue) => void;
  onDelete: (uid: string) => void;
}

export default function ReminderRow({
  reminder,
  onToggle,
  onSave,
  onDelete,
}: Props) {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <ReminderEditor
        initialData={{
          uid: reminder.uid,
          name: reminder.name,
          scheduleConfig: reminder.scheduleConfig,
          sendSms: reminder.sendSms,
          sendEmail: reminder.sendEmail,
          isEnabled: reminder.isActive,
        }}
        onCancel={() => setEditing(false)}
        onSave={(data: ReminderEditorValue) => {
          onSave(reminder.uid, data);
          setEditing(false);
        }}
      />
    );
  }

  return (
    <Box
      display="flex"
      sx={{ borderRadius: "12px", my: 1, background: "var(--fx-surface-base, #FFFFFF)" }}
      alignItems="center"
      justifyContent="space-between"
      p={0.5}
    >
      <Box display="flex" alignItems="center" gap={1} paddingX={1}>
        <NotificationsActiveOutlined sx={{ color: colors.gray[300], fontSize: 20 }} />

        <Typography sx={{ fontWeight: 600 }} fontSize={10}>
          {reminder.name}
        </Typography>

        <Typography
          sx={{
            fontSize: 10,
            color: colors.orange.base,
            fontWeight: 700,
            mt: 0.2,
            ml: 3,
          }}
        >
          {[reminder.sendSms && "SMS", reminder.sendEmail && "EMAIL"]
            .filter(Boolean)
            .join(" • ")}
        </Typography>
      </Box>

      <Box>
        <Switch
          checked={reminder.isActive}
          onChange={(_, checked) => onToggle(reminder.uid, checked)}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: colors.orange.base,
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: colors.orange[400],
            },
            mr: 4,
          }}
          size="small"
        />

        <IconButton onClick={() => setEditing(true)}>
          <EditIcon sx={{ color: colors.gray[300], fontSize: 15 }} />
        </IconButton>

        <IconButton onClick={() => onDelete(reminder.uid)}>
          <DeleteIcon sx={{ color: colors.gray[300], fontSize: 15 }} />
        </IconButton>
      </Box>
    </Box>
  );
}